import { useQuery } from '@tanstack/react-query'

import { UserRoles } from '@sparkai/shared-types'

import { apiClient } from '../apiClient'

export const USER_LIST_KEY = 'user-list'
export const USER_BY_ID_KEY = 'user-by-id'

type UserListResponse = {
  app_user_id: string
  date_created: string
  date_updated: string
  email: string
  name: string
  role: UserRoles
  org: string
  avatar_url: string
}

type UserGetByIdResponse = {
  user: UserListResponse
}

export function useGetUsersListByRole(role?: UserRoles) {
  return useQuery({
    queryKey: [USER_LIST_KEY, role],
    queryFn: async () => (await apiClient.get<UserListResponse>(`/int/app_user`, { params: { role } })).data,
    refetchOnWindowFocus: false,
    retry: false,
    enabled: Boolean(role),
  })
}

export function useGetUserById(id: string) {
  return useQuery({
    queryKey: [USER_BY_ID_KEY, id],
    queryFn: async () => (await apiClient.get<UserGetByIdResponse>(`/int/app_user/${id}`)).data,
    refetchOnWindowFocus: false,
    retry: false,
    enabled: Boolean(id),
  })
}
